export const ANALYTICS_BOARDS = '/analytics/boards/:project_id';
export const BOARD_BY_ID = '/analytics/boards/:project_id/:id';
export const BOARD_ITEMS = '/analytics/charts/:board_id';
export const BOARD_TOOL_BY_ID = '/analytics/charts/:id/:chart_id';
export const UPDATE_BOARD_CHART = '/analytics/charts/:id';
export const GET_TABLE_EXTERNAL_DATA = '/analytics/tables/:id';
